<template>
  <div class="countdown">
    <div class="countdown-wrapper">
      <div v-html="value.right_text" class="countdown__text text-left"></div>
      <div v-html="value.left_text" class="countdown__text text-center"></div>
      <CountdownTimer :value="value.release_date" @update="$emit('update')" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    value: Object,
  },
};
</script>

<style scoped lang="scss">
.countdown-wrapper {
  font-family: "Roboto Condensed";
  min-height: 120px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-image: url("~@/assets/banner.png");
  background-size: cover;
  background-position: center;
  padding: 20px 40px;
  font-weight: 600;
  color: #ffffff;
}

.countdown__text {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: normal;
  white-space: pre-line;
}

.countdown__text.text-center {
  text-transform: none;
  font-weight: 700;
  max-width: 800px;
  padding: 0 auto;
  font-size: 24px;
  line-height: 25px;
}

.temp-presented-by {
  font-size: 20px;
}

@media screen and (max-width: 960px) {
  .countdown-wrapper {
    padding: 20px 50px;
  }
}

@media screen and (max-width: 700px) {
  .countdown-wrapper {
    padding: 12px;
    flex-direction: column;
  }

  .countdown__text {
    text-align: center !important;
    font-size: 1em;
  }

  .countdown__text.text-center {
    margin-bottom: 1em;
    margin-top: 1em;
  }
}
</style>
